export default function validateContact(contactData) {
  const errors = [];
  const warnings = [];
  
  if (!contactData?.name || !contactData.name.trim()) {
    errors.push("Name is required.");
  }
  if (!contactData?.email || !contactData.email.trim()) {
    errors.push("Email is required.");
  } else if (!/\S+@\S+\.\S+/.test(contactData.email)) {
    warnings.push("Email format looks invalid.");
  }
  if (!contactData?.phone || !contactData.phone.trim()) {
    errors.push("Phone number is required.");
  }
  if (!contactData?.role || !contactData.role.trim()) {
    warnings.push("Professional Title (Role) is recommended.");
  }
  if (!contactData?.city || !contactData.city.trim()) {
    warnings.push("City/Location is recommended.");
  }

  // Calculate completion percentage
  let filledCount = 0;
  const fields = ['name', 'email', 'phone', 'role', 'city'];
  fields.forEach(f => {
    if (contactData?.[f] && contactData[f].trim()) filledCount++;
  });
  const percentage = Math.round((filledCount / fields.length) * 100);

  return {
    id: "contact",
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}
